import $ from 'jquery'
import _ from 'underscore'
import TemplateView from '../TemplateView'
import {CREATE_TASKS_CONSTANTS, CreateTasksCustomerProjectSelectorErrors, CreateTasksCustomerProjectSelectorWarnings} from './constants'
import messageResource from '../messageResource'
import {arrayToSet, filterSet, trim} from '../atUtils'
import {setFocusIntoFieldWithPlaceholder} from '../atBrowserUtils'
import CustomCheckbox from '../components/customCheckbox/CustomCheckbox'
import ScrollView from '../ScrollView'
import {EntityTextLimits} from 'constants'
import CPCombobox from '../taskManagement/components/CPCombobox'

export class CreateTasksCustomerProjectSelector extends TemplateView {
    constructor({
                    customers,
                    projects,
                    canEditHierarchy,
                    selectedCustomerId,
                    selectedProjectId,
                    changesCallback,
                    userManagementAssignmentsData,
                    validationCallback,
                    scrollableContainer,
                }) {
        super(null)


        this.params = {
            customers,
            projects,
            canEditHierarchy,
            selectedCustomerId,
            selectedProjectId,
            changesCallback,
            userManagementAssignmentsData,
            validationCallback,
            scrollableContainer,
            manageAssignments: {
                allManagementScopeAssigned: userManagementAssignmentsData.canManageAllScope,
                customerAssignments: userManagementAssignmentsData.customerAssignments,
                projectAssignments: userManagementAssignmentsData.projectAssignments
            }
        }

        this.errors = {};
        this.warnings = {};

        this.changesCallback = this.params.changesCallback;
        this.scrollableContainer = this.params.scrollableContainer;

        this.customers = this.params.customers ? this.params.customers : [];
        this.projects = this.params.projects ? this.params.projects : [];

        this.withInactive = false;
        this.containerClass = 'createTasksCustomerProjectSelector';

        this.selectedProjectNamesSet = {}

        this.state = {
            selectedCustomerId: CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX,
            selectedProjectId: CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX,
        }
    }

    templateModel() {
        return {
            maxNameLength: EntityTextLimits.MAX_CPT_NAME,
        }
    }

    messageKeys() {
        return {
            cpTitle: 'add_new_tasks.select_customer_and_project',
            customerNotSelectedErr: 'add_new_tasks.err.customerid_not_selected',
            customerNameEmptyErr: 'add_new_tasks.err_customer_name_empty',
            customerNameExistsErr: 'add_new_tasks.err_customer_exists',
            noActiveCustomersWarn: 'add_new_tasks.no_active_customers',
            newCustomerNamePlaceholder: 'add_new_tasks.new_customer_name.placeholder',
            projectNotSelectedErr: 'add_new_tasks.err.projectid_not_selected',
            noActiveProjectsWarn: 'add_new_tasks.no_active_projects',
            newProjectNamePlaceholder: 'add_new_tasks.new_project_name.placeholder',
            newProjectNameEmptyErr: 'add_new_tasks.err_project_name_empty',
            newProjectNameExistsErr: 'add_new_tasks.err_project_exists',
            emptyProjectListErr: 'add_new_tasks.err.select_one_or_more_project_names'
        }
    }

    templateHtml() {
        return '<div class="selectCustomerAndProject">' +
               '     <div class="selectCPTitle"><%-cpTitle%></div>' +

               '        <table cellpadding=0 cellspacing=0>' +
               '            <tr class="selectCustomerRow">' +
               '                <td>' +
               '                    <div class="customerSelector customerOrProjectSelector selectorWithPlaceholderContainer"></div>' +
               '                </td>' +
               '                <td class="selectCustomerErrorCell">' +
               '                    <div class="errorMsg"><%-customerNotSelectedErr%></div>' +
               '                    <div class="warningMsg"><%-noActiveCustomersWarn%></div>' +
               '                </td>' +
               '            </tr>' +
               '            <tr class="selectCustomerRow">' +
               '                <td>' +
               '                    <input class="newCustomer newCustomerProjectField inputFieldWithPlaceholder" maxlength="<%=maxNameLength%>"' +
               '                           placeholder="<%=newCustomerNamePlaceholder%>"/>' +
               '                </td>' +
               '                <td class="newCustomerErrorCell">' +
               '                    <div class="errorMsg emptyName"><%-customerNameEmptyErr%></div>' +
               '                    <div class="errorMsg alreadyExist"><%-customerNameExistsErr%></div>' +
               '                </td>' +
               '            </tr>' +
               '            <tr class="selectProjectRow projectSelectorRow">' +
               '                <td>' +
               '                    <div class="projectSelector customerOrProjectSelector selectorWithPlaceholderContainer"></div>' +
               '                </td>' +
               '                <td class="selectProjectErrorCell">' +
               '                    <div class="errorMsg"><%-projectNotSelectedErr%></div>' +
               '                    <div class="warningMsg"><%-noActiveProjectsWarn%></div>' +
               '                </td>' +
               '            </tr>' +
               '            <tr class="selectProjectRow">' +
               '                <td>' +
               '                    <input class="newProject newCustomerProjectField inputFieldWithPlaceholder" maxlength="<%=maxNameLength%>"' +
               '                           placeholder="<%=newProjectNamePlaceholder%>"/>' +
               '                </td>' +
               '                <td class="newProjectErrorCell">' +
               '                    <div class="errorMsg emptyName"><%-newProjectNameEmptyErr%></div>' +
               '                    <div class="errorMsg alreadyExist"><%-newProjectNameExistsErr%></div>' +
               '                </td>' +
               '            </tr>' +
               '            <tr class="selectProjectRow">' +
               '                <td>' +
               '                    <div class="projectList"></div>' +
               '                </td>' +
               '                <td class="emptyProjectListErrorCell">' +
               '                    <div class="errorMsg emptyProjectList"><%-emptyProjectListErr%></div>' +
               '                </td>' +
               '            </tr>' +
               '        </table>' +
               '' +
               '</div>'
    }


    afterRender() {
        this.container = this.$el[0]
        this.projectListContainer = this.find('.projectList');
        this.customerSelectorContainer = this.find('.customerSelector.customerOrProjectSelector')[0]
        this.projectSelectorContainer = this.find('.projectSelector.customerOrProjectSelector')[0]

        this.newCustomerField = this.find('.newCustomer.newCustomerProjectField')[0]
        this.newProjectField = this.find('.newProject.newCustomerProjectField')[0]
        $(this.newCustomerField).placeholder();
        $(this.newProjectField).placeholder();

        this.createCustomerSelector(this.params.selectedCustomerId);
        this.createProjectSelector(
            this.params.selectedCustomerId
                ? this.getProjectsOfCustomer(this.params.selectedCustomerId)
                : this.params.projects,
            this.params.selectedProjectId
        );

        this.addFieldHandlers(
            this.newCustomerField,
            [
                CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EMPTY,
                CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EXISTS
            ]
        );
        this.addFieldHandlers(
            this.newProjectField,
            [
                CreateTasksCustomerProjectSelectorErrors.PROJECT_EMPTY,
                CreateTasksCustomerProjectSelectorErrors.PROJECT_EXISTS
            ]
        );

        this.createProjectList(this.params.selectedCustomerId ? this.getProjectsOfCustomer(this.params.selectedCustomerId) : this.params.projects);

        if (!this.customersExist()) {
            this.selectCustomer(CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX)
            this.selectProject(CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX)
            $(this.container).addClass("newCustomer newProject");
            setFocusIntoFieldWithPlaceholder(this.newCustomerField);
        }

        return this;
    }

    createAdditionalCustomerItems() {
        const items = []
        if (this.params.manageAssignments.allManagementScopeAssigned) {
            items.push({
                name: messageResource.getEscapedMessage("add_new_tasks.option.new_customer"),
                id: CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX
            });
        }
        var allActiveCustomersMsgKey = "add_new_tasks.option.all" + ( this.params.manageAssignments.allManagementScopeAssigned ? "" : "_available" ) + "_active_customers";
        items.push({
            name: messageResource.getEscapedMessage(allActiveCustomersMsgKey),
            id: CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX
        });

        return items
    };

    createAdditionalProjectItems() {
        let items = []

        if (this.canManageProjectsOfCustomer(this.getSelectedCustomerId())) {
            items.push({
                name: messageResource.getEscapedMessage("add_new_tasks.option.new_project"),
                id: CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX
            });
        }
        var allActiveProjectsMsgKey = "add_new_tasks.option.all" + ( this.canManageProjectsOfCustomer(
            this.getSelectedCustomerId()) ? "" : "_available" ) + "_active_projects";
        items.push({
                name: messageResource.getEscapedMessage(allActiveProjectsMsgKey),
                id: CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX
            },
            {
                name: messageResource.getEscapedMessage("add_new_tasks.option.selected_active_projects"),
                id: CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX
            });

        return items
    };

    createListSelector(items, additionalItems, containerEl, selectorCls, changeCallback ,messageKeys, selectCallback, emptySelectionId) {
        $(containerEl).empty();

        const handler = (value) => {
            if (value === CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX ||
                value === CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX)
                $(containerEl).addClass("notSelected")
            else
                $(containerEl).removeClass("notSelected")

            if (changeCallback)
                changeCallback(value)

            if (this.params.changesCallback)
                this.params.changesCallback()
        };

        const listSelector = new CPCombobox({
            ...messageKeys,
            onItemSelectedCb: (item) => {
                selectCallback(item)
                handler(item.id)
            },
            emptySelectionId,
        }).init($(containerEl))

        listSelector.setState({
            items: items,
            additionalItems: additionalItems,
        })

        return listSelector;
    };

    createProjectList(projects) {
        if (!projects || projects.length === 0)
            return;

        const projectNamesSet = arrayToSet(projects.map(p => p.name))
        this.selectedProjectNamesSet = filterSet(this.selectedProjectNamesSet, name => projectNamesSet[name])

        const items = projects.map(project => new CustomCheckbox({
            label: project.name,
            checked: this.selectedProjectNamesSet[project.name],
            containerAdditionalClass: 'projectListItem',
            onChange: ({checked}) => this.selectedProjectNamesSet[project.name] = checked
        }))

        this.selectedProjectsList = new ScrollView(null, 22).init(this.projectListContainer)
        this.selectedProjectsList.setItems(items)
    }

    customerChanged() {
        this.params.changesCallback()
        this.removeAllErrors();
        this.removeWarning(CreateTasksCustomerProjectSelectorWarnings.NO_CUSTOMERS);
        this.removeWarning(CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);

        $(this.container).removeClass("newCustomer");

        var customerValue = this.getSelectedCustomerId();
        var projectValue = this.getSelectedProjectId();

        switch (parseInt(customerValue)) {
            case CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX: {
                this.selectProject(CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX)
                this.projectChanged();
                this.loadCustomerProjects();
                break;
            }
            case CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX: {
                if (projectValue !== CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX &&
                    projectValue !== CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX &&
                    projectValue !== CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX &&
                    projectValue !== CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX) {
                    this.selectProject(CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX)
                    this.projectChanged();
                }

                this.loadCustomerProjects();
                if (!this.customersExist()) {
                    this.addWarning(CreateTasksCustomerProjectSelectorWarnings.NO_CUSTOMERS);
                }
                if (!this.projectsExist() &&
                    ( projectValue === CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX ||
                      projectValue === CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX )) {
                    this.addWarning(CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);
                }
                break;
            }
            case CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX: {
                if (this.canManageProjectsOfCustomer(customerValue)) {
                    $(this.container).addClass("newCustomer");
                    this.selectProject(CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX)
                    this.projectChanged();
                    setFocusIntoFieldWithPlaceholder(this.newCustomerField);
                }
                break;
            }
            default: {
                if (this.customerHasProjects(customerValue)) {
                    this.loadCustomerProjects();
                } else {
                    this.selectProject(CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX)
                    this.projectChanged();
                }
            }
        }
    };

    projectChanged() {
        this.params.changesCallback()
        this.removeAllErrors();
        this.removeWarning(CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);

        $(this.container).removeClass("newProject selectProjectsFromList");

        var customerValue = this.getSelectedCustomerId();
        var projectValue = this.getSelectedProjectId();

        if (projectValue === CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX) {
            if (!this.projectsExist() ||
                ( this.isConcreteCustomerId(customerValue) &&
                  !this.customerHasProjects(customerValue) )) {
                this.addWarning(CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);
            }
        }
        else if (projectValue === CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX) {
            $(this.container).addClass("selectProjectsFromList");
            if (!this.projectsExist() || (this.isConcreteCustomerId(customerValue) && !this.customerHasProjects(customerValue))) {
                this.addWarning(CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);
            }
            if (customerValue !== CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX && !this.isConcreteCustomerId(customerValue)) {
                this.selectCustomer(CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX)
                this.loadCustomerProjects();
            }
            this.selectedProjectsList.refreshScroll()
        }
        else if (this.isConcreteProjectId(projectValue)) {
            var customerId = this.findProjectCustomerId(projectValue);
            if (customerId !== customerValue) {
                this.selectCustomer(customerId)
                this.loadCustomerProjects();
            }
        }
        else if (projectValue === CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX && this.canManageProjectsOfCustomer(customerValue)) {
            $(this.container).addClass("newProject");
            this.loadCustomerProjects();
            setFocusIntoFieldWithPlaceholder(this.newProjectField);
        }
    };

    loadCustomerProjects() {
        var customerValue = this.getSelectedCustomerId();
        var projectValue = this.getSelectedProjectId();
        var projects = this.getProjectsOfCustomer(customerValue, this.withInactive);
        this.createProjectSelector(projects, projectValue);

        this.updateProjectList(projects);
    };

    updateProjectList(projects) {
        $(this.projectListContainer).empty();
        this.createProjectList(this.getSelectedCustomerId() !== CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX ? projects : this.params.projects);
    };

    hasSelectedProjects() {
        return !_.isEmpty(this.selectedProjectNamesSet)
    };

    getSelectedProjectsNames() {
        return Object.keys(this.selectedProjectNamesSet)
    };

    getSelectedProjectsNamesSet() {
        return this.selectedProjectNamesSet
    };

    isConcreteCustomerId(selected) {
        return ![
            CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX,
            CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX,
            CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX
        ].includes(selected);
    };

    isConcreteProjectId(selected) {
        return ![
            CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX,
            CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX,
            CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX,
            CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX
        ].includes(selected);
    };

    validate() {
        this.removeErrors([
            CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EMPTY,
            CreateTasksCustomerProjectSelectorErrors.PROJECT_EMPTY,
            CreateTasksCustomerProjectSelectorErrors.CUSTOMER_NOT_SELECTED,
            CreateTasksCustomerProjectSelectorErrors.PROJECT_NOT_SELECTED,
            CreateTasksCustomerProjectSelectorErrors.PROJECTS_NOT_SELECTED
        ]);

        const customerValue = this.getSelectedCustomerId();
        const projectValue = this.getSelectedProjectId();

        let projectsWarningShowed = this.hasWarning(CreateTasksCustomerProjectSelectorWarnings.NO_PROJECTS);

        if (customerValue === CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX)
            this.addError(CreateTasksCustomerProjectSelectorErrors.CUSTOMER_NOT_SELECTED);

        if (projectValue === CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX)
            this.addError(CreateTasksCustomerProjectSelectorErrors.PROJECT_NOT_SELECTED);

        if (projectsWarningShowed)
            this.addError(CreateTasksCustomerProjectSelectorErrors.NO_PROJECTS);

        if (this.hasWarning(CreateTasksCustomerProjectSelectorWarnings.NO_CUSTOMERS))
            this.addError(CreateTasksCustomerProjectSelectorErrors.NO_CUSTOMERS);

        if (projectValue === CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX && !projectsWarningShowed && !this.hasSelectedProjects())
            this.addError(CreateTasksCustomerProjectSelectorErrors.PROJECTS_NOT_SELECTED);

        if (customerValue === CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX && $(this.newCustomerField).pVal() == "")
            this.addError(CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EMPTY);

        if (projectValue === CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX && $(this.newProjectField).pVal() == "")
            this.addError(CreateTasksCustomerProjectSelectorErrors.PROJECT_EMPTY);

        return !this.hasErrors();
    };

    hasErrors() {
        //noinspection LoopStatementThatDoesntLoopJS
        for (let prop in this.errors) {
            if (this.errors[prop] === true)
                return true;
        }
        return false;
    };

    addFieldHandlers(field, errorsToRemove) {
        var self = this;
        var keyUpChangesHandler = function() {
            this.keyPressed = false;
            if ((!this.prevValue && !!this.value) || this.prevValue !== this.value) {
                self.removeErrors(errorsToRemove);
                if (self.params.changesCallback)
                    self.params.changesCallback();
                this.prevValue = this.value;
            }
        };

        $(field).keypress(function() {
            this.keyPressed = true;
        });

        $(field).keyup(function() { keyUpChangesHandler.call(this); });

        $(field).blur(function() {
            $(this).pVal(trim($(this).pVal()));
            //see Bug 48539
            if (this.keyPressed) keyUpChangesHandler.call(this);
        });
    };

    getValues() {
        const customerValue = this.getSelectedCustomerId();
        const projectValue = this.getSelectedProjectId();

        const newCustomerName = customerValue === CREATE_TASKS_CONSTANTS.NEW_CUSTOMER_OPTION_INDEX ?
                                $(this.newCustomerField).pVal() :
                                null;
        const newProjectName = projectValue === CREATE_TASKS_CONSTANTS.NEW_PROJECT_OPTION_INDEX ?
                               $(this.newProjectField).pVal() :
                               null;

        const selectedProjectNames = projectValue === CREATE_TASKS_CONSTANTS.SELECTED_PROJECTS_OPTION_INDEX ?
                                     this.getSelectedProjectsNames() : null;

        return {
            customerId: customerValue,
            projectId: projectValue,
            newCustomerName: newCustomerName,
            newProjectName: newProjectName,
            selectedProjectNames: selectedProjectNames
        };
    };

    addError(error) {
        this.errors[error] = true;
        $(this.container).addClass(error);
    };

    removeError(error) {
        this.errors[error] = false;
        $(this.container).removeClass(error);

        if (this.params.validationCallback)
            this.params.validationCallback();
    };

    removeErrors(errors) {
        for (let i = 0; i < errors.length; i++)
            this.removeError(errors[i]);
    };

    removeAllErrors() {
        this.removeErrors([
            CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EMPTY,
            CreateTasksCustomerProjectSelectorErrors.PROJECT_EMPTY,
            CreateTasksCustomerProjectSelectorErrors.CUSTOMER_NOT_SELECTED,
            CreateTasksCustomerProjectSelectorErrors.PROJECT_NOT_SELECTED,
            CreateTasksCustomerProjectSelectorErrors.NO_CUSTOMERS,
            CreateTasksCustomerProjectSelectorErrors.NO_PROJECTS,
            CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EXISTS,
            CreateTasksCustomerProjectSelectorErrors.PROJECT_EXISTS,
            CreateTasksCustomerProjectSelectorErrors.PROJECTS_NOT_SELECTED
        ]);
    };

    addCustomerNotSelectedError() {
        this.addError(CreateTasksCustomerProjectSelectorErrors.CUSTOMER_NOT_SELECTED);
    };

    addProjectNotSelectedError() {
        this.addError(CreateTasksCustomerProjectSelectorErrors.PROJECT_NOT_SELECTED);
    };

    addNoActiveCustomersError() {
        this.addError(CreateTasksCustomerProjectSelectorErrors.NO_CUSTOMERS);
    };

    addNoActiveProjectsError() {
        this.addError(CreateTasksCustomerProjectSelectorErrors.NO_PROJECTS);
    };

    addCustomerExistsError() {
        this.addError(CreateTasksCustomerProjectSelectorErrors.CUSTOMER_EXISTS);
    };

    addProjectExistsError() {
        this.addError(CreateTasksCustomerProjectSelectorErrors.PROJECT_EXISTS);
    };

    addWarning(warning) {
        this.warnings[warning] = true;
        $(this.container).addClass(warning);
    };

    removeWarning(warning) {
        this.warnings[warning] = false;
        $(this.container).removeClass(warning);
    };

    hasWarning(warning) {
        return this.warnings[warning];
    };

    removeProject(projectId) {
        for (var i = 0; i < this.params.projects.length; i++) {
            if (this.params.projects[i].id === projectId) {
                this.params.projects.splice(i, 1);
                break;
            }
        }

        this.updateProjectSelector();
    };

    setCanCreateCustomerProject(canCreateCustomerProject) {
        this.params.canEditHierarchy = canCreateCustomerProject;

        this.createCustomerSelector(this.getSelectedCustomerId());
        this.createProjectSelector(this.params.projects, this.getSelectedProjectId());
        this.customerChanged();
    };

    removeAllProjectsOfSelectedCustomer() {
        const customerValue = this.getSelectedCustomerId();
        if (!this.isConcreteCustomerId(customerValue)) {
            this.setProjectsAndUpdateSelector(null);
        }
        else {
            this.params.projects = this.params.projects.filter(project => project.customerId !== customerValue)

            this.createProjectSelector(this.params.projects);
        }
    };

    removeProjectsFromList(selectedProjectNames, customerId) {
        for (let i = 0; i < this.params.projects.length; i++) {
            if ($.inArray(this.params.projects[i].name, selectedProjectNames) !== -1 &&
                ( !this.isConcreteCustomerId(customerId) || this.params.projects[i].customerId === customerId )) {
                this.params.projects.splice(i, 1);
                i--;
            }
        }

        $(this.container).removeClass("selectProjectsFromList");
        this.updateProjectSelector();
    };

    updateProjectSelector(saveSelectedProjectId) {
        const selectedCustomerId = this.getSelectedCustomerId();
        const visibleProjects = this.isConcreteCustomerId(selectedCustomerId) ? this.getProjectsOfCustomer(selectedCustomerId) : this.params.projects;
        this.createProjectSelector(visibleProjects, saveSelectedProjectId ? this.getSelectedProjectId() : null);


        this.updateProjectList(visibleProjects);
    };

    canManageProjectsOfCustomer(customerValue) {
        return this.params.canEditHierarchy && (this.params.manageAssignments.allManagementScopeAssigned
                                                || (this.isConcreteCustomerId(customerValue) && _.some(this.params.manageAssignments.customerAssignments,
                function(c) {return c.id === customerValue}))
                                                || (!this.isConcreteCustomerId(customerValue) && this.params.manageAssignments.customerAssignments.length > 0))
    }

    createCustomerListItems() {
        const items = [];

        for (let i = 0; i < this.params.customers.length; i++) {
            const customer = this.params.customers[i];
            items.push({
                name: customer.name,
                id: customer.id,
                archived: !customer.activeCustomer
            });
        }

        return items;
    };

    createProjectListItems(projects) {
        const items = [];

        for (let i = 0; i < projects.length; i++) {
            items.push({
                name: projects[i].name,
                id: projects[i].id,
                archived: !projects[i].activeProject,
            });
        }

        return items;
    };

    createCustomerSelector(selectedValue) {
        const items = this.createCustomerListItems()
        const additionalItems = this.createAdditionalCustomerItems()
        this.customerButton = this.createListSelector(items,
            additionalItems,
            this.customerSelectorContainer,
            "customerListSelector",
            () => this.customerChanged(),
            {
                emptySelectionMessageKey: "add_new_tasks.option.select_customer",
                notFoundMessageKey: "task.list.move_to.no_customers_found",
                hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_customers',
                hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_customers',
                emptyListMessageKey: "task.list.move_to.no_customers",
            },
            (entity) => {
                this.selectCustomer(entity.id)
            },
            CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX);

        let selectedItem = items.find(item => item.id === selectedValue) || additionalItems.find(item => item.id === selectedValue)
        this.selectCustomer(selectedItem ? selectedItem.id : CREATE_TASKS_CONSTANTS.SELECT_CUSTOMER_OPTION_INDEX)
    };

    createProjectSelector(projects, selectedValue) {
        const items = this.createProjectListItems(projects)
        const additionalItems = this.createAdditionalProjectItems()
        this.projectButton = this.createListSelector(items,
            additionalItems,
            this.projectSelectorContainer,
            "projectListSelector",
            () => this.projectChanged(),
            {
                emptySelectionMessageKey: "add_new_tasks.option.select_project",
                notFoundMessageKey: "task.list.move_to.no_projects_found",
                hiddenItemsCollapsedMessageKey: 'task.list.move_to.show_archived_projects',
                hiddenItemsExpandedMessageKey: 'task.list.move_to.hide_archived_projects',
                emptyListMessageKey: "task.list.move_to.no_projects",
            },
            (entity) => {
                this.selectProject(entity.id)
            },
            CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX);

        let selectedItem = items.find(item => item.id === selectedValue) || additionalItems.find(item => item.id === selectedValue)
        this.selectProject(selectedItem ? selectedItem.id : CREATE_TASKS_CONSTANTS.SELECT_PROJECT_OPTION_INDEX)
    };

    getSelectedCustomerId() {
        return this.state.selectedCustomerId
    };

    getSelectedProjectId() {
        return this.state.selectedProjectId
    };

    customerHasProjects(customerId) {
        for (let i = 0; i < this.params.projects.length; i++) {
            if (this.params.projects[i].customerId === customerId)
                return true;
        }
        return false;
    };

    findProjectCustomerId(projectId) {
        for (var i = 0; i < this.params.projects.length; i++) {
            if (this.params.projects[i].id === projectId)
                return this.params.projects[i].customerId;
        }
        return -1;
    };

    getProjectsOfCustomer(customerId) {
        const result = [];
        for (let i = 0; i < this.params.projects.length; i++) {
            const project = this.params.projects[i];
            if ((customerId <= 0 || project.customerId === customerId) && ( this.withInactive || project.activeProject ))
                result[result.length] = project;
        }
        return result;
    };

    setCustomersAndProjectsAndUpdateSelector(customers, projects) {
        this.params.customers = customers ? customers : [];
        this.createCustomerSelector();

        this.setProjectsAndUpdateSelector(projects);
    };

    setProjectsAndUpdateSelector(projects) {
        this.params.projects = projects ? projects : [];
        this.updateProjectSelector(true);
    };

    customersExist() {
        return this.params.customers.length !== 0;
    };

    projectsExist() {
        return this.params.projects.length !== 0;
    };

    selectCustomer(customerId) {
        this.customerButton.setState({
            selectedItemId: customerId
        })
        this.setStateInternal({
            selectedCustomerId: customerId
        })
    }

    selectProject(projectId) {
        this.projectButton.setState({
            selectedItemId: projectId
        })
        this.setStateInternal({
            selectedProjectId: projectId
        })
    }

}

export default CreateTasksCustomerProjectSelector



// WEBPACK FOOTER //
// ./web/js/addNewTasks/CreateTasksCustomerProjectSelector.js